import Button from '../../Button/Button.js';
import Card from '../../Card/Card.js';
import List from '../../List/List.js';
import Text from '../../Text/Text.js';
import { IGridConfiguration } from '../models/IGridConfiguration.js';

export const gridConfiguration: IGridConfiguration = {
	components: {
		'base.button': {
			key: 'base.button',
			component: Button,
		},
		'base.card': {
			key: 'base.card',
			component: Card,
		},
		'base.text': {
			key: 'base.text',
			component: Text,
		},
		'base.list1': {
			key: 'base.list1',
			component: List,
		},
		'base.list2': {
			key: 'base.list2',
			component: List,
		},
		'base.list3': {
			key: 'base.list3',
			component: List,
		},
		'base.list4': {
			key: 'base.list4',
			component: List,
		},
		'base.list5': {
			key: 'base.list5',
			component: List,
		},
		'base.list6': {
			key: 'base.list6',
			component: List,
		},
	},
};
